var _linearGradient, _path, _path2, _path3, _path4, _linearGradient2, _path5, _linearGradient3, _path6, _linearGradient4, _path7, _linearGradient5, _path8, _linearGradient6, _path9, _linearGradient7, _path10, _linearGradient8, _path11, _linearGradient9, _path12, _linearGradient10, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: -7747.177,
    y1: -880.664,
    x2: -7746.177,
    y2: -880.664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M40.308 49.299H21.816a2.957 2.957 0 01-2.948-2.948V7.4a2.957 2.957 0 012.948-2.948h18.492M44.483 4.451h18.133a2.953 2.953 0 012.948 2.948V46.35a2.953 2.953 0 01-2.948 2.948H44.483"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M18.867 12.299h-3.983a2.953 2.953 0 00-2.948 2.948v38.957a2.957 2.957 0 002.948 2.948H39.07M65.564 12.299h4.551a2.953 2.953 0 012.948 2.948v38.957a2.957 2.957 0 01-2.948 2.948H45.459M44.483 4.451v1.04c0 1.147-.938 2.09-2.085 2.09s-2.09-.943-2.09-2.09v-1.04M44.483 49.299v.579c0 1.147-.938 2.09-2.085 2.09s-2.09-.943-2.09-2.09v-.579M45.459 57.152a3.214 3.214 0 01-.906 1.742 3.218 3.218 0 01-2.289.954 3.258 3.258 0 01-3.195-2.696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M57.405 14.952s-.442-2.559-2.559-2.559-2.685 2.559-2.685 2.559l5.497 4.168M52.413 19.12s.442 2.559 2.559 2.559 2.685-2.559 2.685-2.559M54.909 10.214v2.179M54.909 21.679v2.18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M57.405 14.952s-.442-2.559-2.559-2.559-2.685 2.559-2.685 2.559l5.497 4.168M52.413 19.12s.442 2.559 2.559 2.559 2.685-2.559 2.685-2.559M54.909 10.214v2.179M54.909 21.679v2.18"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 23.492,
    y1: 21.238,
    x2: 37.722,
    y2: 21.238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.118 18.617h12.98v5.242h-12.98z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 23.492,
    y1: 34.341,
    x2: 37.722,
    y2: 34.341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M37.098 34.341h-12.98"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 23.492,
    y1: 29.1,
    x2: 37.722,
    y2: 29.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M37.098 29.1h-12.98"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 23.492,
    y1: 44.823,
    x2: 37.722,
    y2: 44.823
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M37.098 44.823h-12.98"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 23.492,
    y1: 39.582,
    x2: 37.722,
    y2: 39.582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M37.098 39.582h-12.98"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 47.794,
    y1: 44.823,
    x2: 62.024,
    y2: 44.823
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M61.399 44.823h-12.98"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 47.794,
    y1: 39.582,
    x2: 62.024,
    y2: 39.582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M61.399 39.582h-12.98"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 23.492,
    y1: 11.303,
    x2: 37.722,
    y2: 11.303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.118 8.682h12.98v5.242h-12.98z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e",
    gradientUnits: "userSpaceOnUse",
    x1: 47.794,
    y1: 31.72,
    x2: 62.024,
    y2: 31.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_ef56f030bea212b166c549684db5b76f119e51fe0e70a8f25a149737080e781e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M48.419 29.099h12.98v5.242h-12.98z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralLedger);
export default __webpack_public_path__ + "static/media/generalLedger.f33e308a4267e0bc7225bf553d5eaf8d.svg";
export { ForwardRef as ReactComponent };